import { z } from 'zod';

export const validateWithSchema = <T>(schema: z.ZodType<T>, data: unknown): T => {
   try {
      return schema.parse(data);
   } catch (error) {
      console.error('Validation Error:', error);
      throw new Error('Validation failed');
   }
};

export const getSecurityMathQuestion = (): {
   a: number;
   b: number;
   c: number;
   result: number;
} => {
   // random a b  between 2 and 9
   const a = Math.floor(Math.random() * 8) + 2;
   const b = Math.floor(Math.random() * 8) + 2;

   // random c between 0 and 100
   const c = Math.floor(Math.random() * 100);

   return {
      a,
      b,
      c,
      result: a * b + c,
   };
};
